import { render, staticRenderFns } from "./CardInfoComponent.vue?vue&type=template&id=97dd5f40&scoped=true&"
import script from "./CardInfoComponent.vue?vue&type=script&lang=js&"
export * from "./CardInfoComponent.vue?vue&type=script&lang=js&"
import style0 from "./CardInfoComponent.vue?vue&type=style&index=0&id=97dd5f40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97dd5f40",
  null
  
)

export default component.exports